import { render } from "./SuperMenu.vue?vue&type=template&id=b224185c&scoped=true"
import script from "./SuperMenu.vue?vue&type=script&lang=js"
export * from "./SuperMenu.vue?vue&type=script&lang=js"

import "./SuperMenu.vue?vue&type=style&index=0&id=b224185c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b224185c"]])

export default __exports__